import axios from "axios"
import { Message } from "element-ui"
import Bus from "../utils/bus";
//创建axios实例
export const Service = axios.create({
    timeout: 1000 * 15,
    //测试环境 
    // baseURL: "https://backstage.onejob.cn/index",
    //线上环境
    baseURL: "https://xwzc.onejob.cn/index",
})
const url = window.location.href;
Service.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    const openid = localStorage.getItem('openid');
    if (config.url != "/") {
        config.headers['token'] = `${token}`;
        config.headers['openid'] = `${openid}`;
    }
    return config
})
// 响应拦截
Service.interceptors.response.use((response) => {

    if (response.data.code == 300) {
        localStorage.removeItem("token")
        localStorage.removeItem("openid")
        Message({
            message: response.data.msg,
            type: "error"
        })

        window.location.href = url
    }

    return response
}, (err) => {
    const isIE = !!window.ActiveXObject || "ActiveXObject" in window;
    if (err && isIE) {
        Bus.$emit("IE", true);
    }
  
    return err
})


// WEBPACK FOOTER //
// ./src/api/config.js